import { styled } from "styled-components";

export const Note = styled.p`
  padding: 1rem;
  border-radius: 6px;
  background: ${(props) => props.theme.colours.grey[200]};
`;
